export default __webpack_public_path__ + "static/favicon-180-af6c1d41bbffbfb2ed204043ed4dceed.png";